import { JwtTokenDto } from '../../../models/dtos/jwt-token.dto';
import { CredentialsDto } from '../../../models/dtos/credentials.dto';

/**
 * Mock authentication data for testing login functionality
 */

// Valid test credentials
export const mockValidCredentials: CredentialsDto = {
  username: 'testuser',
  password: 'password123',
};

// Invalid test credentials for testing error scenarios
export const mockInvalidCredentials: CredentialsDto = {
  username: 'wrong',
  password: 'wrong',
};

// Incomplete test credentials for testing validation
export const mockIncompleteCredentials: CredentialsDto = {
  username: '',
  password: '',
};

// Mock JWT token for successful authentication
export const mockJwtToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ0ZXN0dXNlciIsIm5hbWUiOiJUZXN0IFVzZXIiLCJpYXQiOjE1MTYyMzkwMjIsImV4cCI6OTk5OTk5OTk5OX0.mock-signature';

/**
 * Validates mock credentials
 * @param username - Username to validate
 * @param password - Password to validate  
 * @returns LoginResponse if valid, null if invalid
 */
export const validateMockCredentials = (request: CredentialsDto): JwtTokenDto | null => {
  if (request.username === mockValidCredentials.username && request.password === mockValidCredentials.password) {
    return { token: mockJwtToken };
  }
  return null;
};
